import KBtn from '@components/k-btn';
import styled from '@emotion/styled';

export const SadaGoogleLoginButton = styled(KBtn)`
  > span {
    margin-left: 8px;
  }
`;
